import type { PublicPriceTier } from '@repo/api-contracts';

/** 수량 입력 문자열 → 1 이상 정수. 비었거나 정수가 아니면 null(검증 실패). */
export const parseOrderQty = (draft: string): number | null => {
  const parsed = Number(draft);

  return Number.isInteger(parsed) && parsed >= 1 ? parsed : null;
};

/** 수량이 속하는 구간 — minQty <= qty 인 구간 중 가장 큰 minQty. tiers 는 minQty 오름차순. */
export const activeTierOf = (
  tiers: readonly PublicPriceTier[],
  qty: number | null,
): PublicPriceTier | null => {
  if (qty === null) {
    return null;
  }

  return [...tiers].reverse().find((tier) => tier.minQty <= qty) ?? null;
};

/**
 * −/+ 한 칸 — 최소 주문 수량 아래로는 내려가지 않는다.
 * 입력이 비었거나 잘못됐으면(null) 최소 주문 수량에서 다시 시작한다.
 */
export const stepOrderQty = (qty: number | null, minOrderQty: number, delta: 1 | -1): number =>
  qty === null ? minOrderQty : Math.max(minOrderQty, qty + delta);
